// import axios from "axios";

class FacebookMetrics {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }
  async getMetrics(product) {
    try {
      let date_start = product.date_start;
      let date_end = product.date_end;
      let facebookMetrics = [];
      let url = `${process.env.VUE_APP_API_BASE_URL}/facebook-metrics/metrics/${product.subcribeid}/${product.countryid}/${date_start}/${date_end}`;
      facebookMetrics = await this.axios.get(url);
      return facebookMetrics.data;
    } catch (err) {
      console.log(err);
    }
  }
  async getMetricsPreviews(campaigns, date_start, date_end) {
    try {
      let c = [];
      for (let index in campaigns) {
        if (!c.includes(campaigns[index])) c.push(campaigns[index]);
      }
      campaigns = c;

      // date_start = date_start;
      // date_end = date_end;
      let facebookMetrics = [];
      let url = `${
        process.env.VUE_APP_API_BASE_URL
      }/facebook-metrics/previews?campaigns_ids=${campaigns.join(
        ","
      )}&date_start=${date_start}&date_end=${date_end}`;
      facebookMetrics = await this.axios.get(url);

      return facebookMetrics.data;
    } catch (err) {
      console.log(err);
    }
  }
}

export default FacebookMetrics;
